/**
 * Super-admin public Save → Save the date on v2-events.
 * Unsave does not call this. Already-featured events are left alone.
 */

import { updateEventField } from '../firestore';
import {
  ensureSaveTheDatePick,
  isHomepageFeaturedEditorialPick,
} from './eventEditorialPick';

const listeners = new Set();

/**
 * @param {(update: { eventId: string, editorialPick: string[] }) => void} listener
 * @returns {() => void}
 */
export function subscribePublicEventPick(listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * @param {string} eventId
 * @param {string[]} editorialPick
 */
export function notifyPublicEventPick(eventId, editorialPick) {
  listeners.forEach((listener) => {
    listener({ eventId, editorialPick });
  });
}

/**
 * Write Save the date when the event is not already featured.
 * @param {Record<string, unknown>|null|undefined} event
 * @returns {Promise<{ promoted: boolean, editorialPick?: string[] }>}
 */
export async function promotePublicEventSaveTheDate(event) {
  const eventId = event?.id;
  if (!eventId) return { promoted: false };
  if (isHomepageFeaturedEditorialPick(event.editorialPick, event)) {
    return { promoted: false };
  }

  const editorialPick = ensureSaveTheDatePick(event.editorialPick, event);
  const result = await updateEventField(eventId, 'editorialPick', editorialPick);
  if (!result?.success) {
    throw new Error(result?.error || 'Could not mark Save the date');
  }
  notifyPublicEventPick(eventId, editorialPick);
  return { promoted: true, editorialPick };
}
